// extracted by mini-css-extract-plugin
module.exports = {"articleAtribute__text":"ArticleAtribute_articleAtribute__text__D_yFc"};